import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { fetchForm, fetchFormResponses } from '../services'
import Loader from './loader'
import RadarChart from './radar-chart'

export default function ChartHOC ({ formId }) {
  const [chartDatasets, setChartDatasets] = useState([])
  const [chartLabels, setChartLabels] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    (async function () {
      const form = await fetchForm(formId)
      setChartLabels(getChartLabels(form))

      const data = await fetchFormResponses(form)
      const datasetDates = Object.keys(data)
      if (!datasetDates.length) {
        return
      }
      setChartDatasets(generateDatasets(data, datasetDates))

      setIsLoading(false)
    })()
  }, []) // eslint-disable-line

  function getChartLabels (form) {
    return form.fields.map(field => field.title)
  }

  function generateDatasets (data, datasetDates) {
    return datasetDates.map(datasetDate => {
      const fieldRefs = Object.keys(data[datasetDate])
      const averageValues = fieldRefs.map(ref => {
        const { answers } = data[datasetDate][ref]
        const total = answers.reduce((acc, value) => acc + (parseInt(value) || 0), 0)
        return total / answers.length
      })

      return {
        label: datasetDate,
        data: averageValues
      }
    })
  }

  return !isLoading
    ? <RadarChart datasets={chartDatasets} labels={chartLabels} />
    : <Loader />
}

ChartHOC.propTypes = {
  formId: PropTypes.string,
}
